import Img from "@/components/Img";

export default function Logo({ siteName, logoUrl, className = "", markSize = 40 }) {
  if (logoUrl) {
    return (
      <Img
        src={logoUrl}
        width={320}
        sizes={`${markSize * 3}px`}
        eager
        alt={siteName}
        style={{ height: markSize }}
        className={`object-contain ${className}`}
      />
    );
  }
  return (
    <svg viewBox="0 0 64 64" fill="none" style={{ height: markSize, width: markSize }} className={className} aria-label={siteName}>
      <path d="M13 47V27l6.5-6.5L26 27v20" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
      <path d="M38 47V27l6.5-6.5L51 27v20" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
      <path d="M25.5 47V18.5L32 12l6.5 6.5V47" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
      <path d="M9 47h46" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M28.5 47v-7.5a3.5 3.5 0 0 1 7 0V47" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}
